import angular from "angular";

/**
 * Controller for (radio button-like) toggle buttons.
 */
export class ToggleButtonsController implements angular.IController {
  public model: angular.INgModelController;

  /** The options to be displayed in the toggle buttons. For each given value, a new button is created. */
  public options: { value: string, label: string }[];

  /** Types supported: "row" - toggle buttons visualized as blocks with an image, "inline" - text-only blocks in a row, "block" - text-only blocks on top of each other.  */
  public type: string;

  /** Toggle button's optional image. */
  public imgSrc: string;

  constructor() {}

  /**
   * Handles the click event for the toggle button.
   * @param {string} value - The value to set for the ngModel.
   */
  public onClick(value: string) {
    this.model.$setViewValue(value);
  }
}